import React, { useContext, useEffect, useState } from "react";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import * as a from "../../../../constants/api";
import * as r from "../../../../constants/routes";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import ListUsers from "../../../../components/Lists/ListUsers";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import pClasses from "../Users.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import SessionContext from "../../../../context/sessionContext";
import Spinner from "../../../../components/Spinner";
import Title from "../../../../components/Title";
import useFetch from "../../../../hooks/useFetch";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";

export default function UserList() {
  const history = useNavigate();
  const { t } = useTranslation();
  const cSession = useContext(SessionContext);

  const [isInfoOpen, setShowInfo] = useState(false);
  const [hasUserChangedGroup, setHasUserChangedGroup] =
    useState<boolean>(false);
  const [listUser, listUserIsLoading, listUserError, listUserFetch]: any =
    useFetch({
      autoInit: false,
    });
  const hasNewGroups = () => {
    listUserFetch({ url: a.API_USERS_ALL_AUDIOFOCO });
  };
  const { company_uid } = cSession ?? {};
  const { sub } = cSession.admin ?? {};
  const { is_admin } = cSession ?? {};
  useEffect(() => {
    if (sub) listUserFetch({ url: a.API_USERS_ALL_AUDIOFOCO });
  }, [listUserFetch, sub, hasUserChangedGroup]);
  const fHasUserChangedGroup = (): boolean | void =>
    setHasUserChangedGroup(!hasUserChangedGroup);

  let _content = null;
  const hasUser = listUser && listUser.length > 0;

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  if (listUserIsLoading) {
    _content = <Spinner center />;
  } else if (hasUser) {
    let infoHowToSend = (
      <section className={pClasses.HowToSendArea}>
        <RoundButton
          title={t("global.toggle_how_to_send_to_the_training_a_user")}
          aLink
          text={t("global.how_to_send_to_the_training_a_user")}
          onClick={() => {
            setShowInfo(!isInfoOpen);
          }}
        />
      </section>
    );

    if (isInfoOpen) {
      let link_to_show_audiofoco = a.AUDIOFOCO_LINK.replace("https://", "");
      link_to_show_audiofoco = link_to_show_audiofoco.replace("http://", "");

      infoHowToSend = (
        <section className={pClasses.HowToSendArea + " " + pClasses.Open}>
          <RoundButton
            title={
              t("global.toggle") +
              t("global.how_to_send_to_the_training_a_user")
            }
            aLink
            className={pClasses.CloseBtn}
            faIcon={faTimes}
            onClick={() => {
              setShowInfo(!isInfoOpen);
            }}
          />
          <Title h2>{t("global.how_to_send_to_the_training_a_user")}</Title>
          <ul className={pClasses.Infos}>
            <li>
              {t("global.share_the_link") + " "}
              {a.AUDIOFOCO_LINK && (
                <a target="_blank" href={a.AUDIOFOCO_LINK} rel="noreferrer">
                  {link_to_show_audiofoco + " "}
                </a>
              )}
              {t("global.with_your_user")}
            </li>
            <li>
              {t("global.info_to_your_user_the") + " "}
              <strong>
                {t("global.company_id") + " "}
                {company_uid && `(${company_uid})`}
              </strong>
              {", " + t("global.the_o") + " "}
              <strong>{t("global.user_id")}</strong>,{" "}
              {t("global.create_by_you_and_the") + " "}
              <strong>{t("global.access_code")}</strong>
              {" " + t("global.generated_by_the_system") + " "}
            </li>
            <li>{t("global.ask_to_user_put_these_data_to_access")}</li>
            <li>{t("global.done_start_training")}!</li>
          </ul>
        </section>
      );
    }

    const configFields: any = {
      userStatus: {
        editable: false,
        hide: false,
      },
      registry: {
        editable: false,
        hide: false,
      },
      group_name: {
        editable: false,
        hide: true,
      },
      birthdate: {
        editable: false,
        hide: true,
      },

      access_code: {
        editable: false,
        hide: true,
      },
      status: {
        editable: false,
        hide: false,
      },

      amt_plays: {
        editable: false,
        hide: false,
      },
      date_last_play: {
        editable: false,
        hide: true,
      },
      professional_email: {
        editable: false,
        hide: true,
      },

      toolbox: {
        editable: false,
        hide: false,
      },
    };

    _content = (
      <>
        {infoHowToSend}

        <ListUsers
          users={listUser}
          company_uid={company_uid}
          showUser
          showActiveStatus
          showAccess_code
          showBirthdate
          showReportUser
          setHasUserChangedGroup={fHasUserChangedGroup}
          configFields={configFields}
          CustomToolbar={CustomToolbar}
        />
      </>
    );
  } else if (listUser && listUser.length === 0 || listUserError?.status === 404) {
    _content = (
      <FriendlyInfo text={t("global.you_does_not_have_users_added")}>
        <RoundButton
          small
          center
          text={t("global.add_users")}
          title={t("global.add_users")}
          onClick={() => history(r.R_A_USERS_ADD_GO)}
        />
      </FriendlyInfo>
    );
  } else if (listUserError) {
    _content = <>Erro ao consultar usuários</>;
  }
  return (
    <>
      <PageHeader
        title={t("global.users_added")}
        subtitle={t("global.list_active_users")}
        btnText={hasUser ? t("global.add_users") : null}
        btnClick={hasUser ? () => history(r.R_A_USERS_ADD_GO) : null}
        companyId={company_uid}
        hasNewGroups={hasNewGroups}
        isAdmin={is_admin}
      />
      <PageMain>{_content}</PageMain>
    </>
  );
}
